import { ChangeEvent, useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { AppContext, UseGetContractorsList, useGetEmployees } from '../../../common';
import { ContractorModel, EmployeeNodeModel } from '../../../models';
import { WorkshiftsSchedulingAPI } from '../../../services/external/APIs';
import { findParentsNodesByChildNode, getChildNodes } from '../../../utils';
import { EmployeesTable } from '../employees-Table/EmployeesTable';
import { TreeEmployees } from '../employees/TreeEmployees';
import { ReportsModalsWrapper } from '../filter-reports/ReportsModalsWrapper';
import { BaseConfirmModal } from '../modals/';
import './index.css';
import MenuBar from './menu-bar/MenuBar';
import {
    OvertimeHomeSnapshot,
    reconcileNodesWithTree,
    restoreOvertimeHomeStateIfPending,
} from '../../../pages/overtime-schedule/utils/overtimeHomeStatePersistence';

export interface ResultIdentifications {
    employessFound: number;
    status: boolean;
    employessNotFound: number;
    identificationsNotFound: string[] | undefined;
}

/**
 * Este componente contiene todos los demas componentes y funciones para la correcta ejecución
 * @returns Componente principal de la aplicacion
 */
export const WorkshiftScheduler = () => {
    const {
        langResources,
        showEmployeesTable,
        handleConsultScheduling,
        setShowEmployeesTable,
        isCollapseTree,
        setIsCollapseTree,
        setEmployeesToShowTable,
        employeesToShowTable,
        setEmployeesSelectedBackup,
        setEndDateScheduling,
        setStartDateScheduling,
        selectedEmployees,
        setSelectedEmployees,
        startDateScheduling,
        endDateScheduling,
    } = useContext(AppContext);

    const [typeOfPerson, setTypeOfPerson] = useState('employees');

    const { contractorsList } = UseGetContractorsList(typeOfPerson);

    const {
        setGroupList,
        groupList,
        isLoadingTree,
        treeEmployees,
        treeEmployeesCopy,
        setTreeEmployees,
        setTreeEmployeesCopy,
    } = useGetEmployees(typeOfPerson);

    const [isSelectAllEmployes, setIsSelectAllEmployes] = useState(false);

    const [contractorSelected, setContractorSelected] = useState<
        ContractorModel | undefined
    >({} as ContractorModel);

    const [employeesFromTemplate, setEmployeesFromTemplate] = useState<
        EmployeeNodeModel[]
    >([]);

    const [isImportSchedulings, setIsImportSchedulings] = useState(false);

    const [searchTearm, setSearchTearm] = useState('');

    const [resultOfFilterByIdentifications, setResultOfFilterByIdentifications] =
        useState<ResultIdentifications>({
            employessFound: 0,
            status: false,
            employessNotFound: 0,
            identificationsNotFound: [],
        });
    const [isOpenIdentificationModal, setIsOpenIdentificationModal] =
        useState(false);

    const [
        isOpenFilterUnattendanceInterruptionsReportModal,
        setIsOpenFilterUnattendanceInterruptionsReportModal,
    ] = useState(false);

    const [
        isOpenFilterWorkingSchedulingsRepotModal,
        setIsOpenFilterWorkingSchedulingsRepotModal,
    ] = useState(false);

    const [
        isOpenFilterInterruptionsRepotModal,
        setIsOpenFilterInterruptionsRepotModal,
    ] = useState(false);

    const [isOpenFilterDailyAssistance, setIsOpenFilterDailyAssistance] =
        useState(false);

    const [isOpenFilterLunchTimeControl, setIsOpenFilterLunchTimeControl] =
        useState(false);

    const pendingRestoreSnapshotRef = useRef<OvertimeHomeSnapshot | null>(null);

    /**
     * Busca los empleados del arbol pueden coincidir por nombre o cedula
     * @param e ChangeEvent<HTMLInputElement>
     */
    const handleFilterEmployeeSelection = (e: ChangeEvent<HTMLInputElement>) => {
        let searchTermValue = e.target.value.toLowerCase();

        setSearchTearm(searchTermValue);

        if (searchTermValue.length > 0) {
            const filterEmplooyees: EmployeeNodeModel[] = treeEmployees.filter((e) =>
                e.text.toLowerCase().includes(searchTermValue)
            );

            const arr2 = findFatherNode2(filterEmplooyees, []);

            const uniqueNodes = Array.from(
                new Map([...filterEmplooyees, ...arr2].map(node => [node.id, node])).values()
            );

            setTreeEmployeesCopy(uniqueNodes);
        } else {
            handleResetSearchTerm();
        }
    };

    const findFatherNode2 = (
        nodesToFindFather: EmployeeNodeModel[],
        nodesFathers: EmployeeNodeModel[]
    ) => {
        const currentNode = nodesToFindFather[0];

        const haveFather = treeEmployees.find(
            (node) => node.id === currentNode?.parent
        );

        if (haveFather) {
            const nodesFiltered = nodesToFindFather.filter(
                (n) => n.id !== currentNode.id
            );
            if (!nodesFathers.includes(haveFather)) {
                nodesFathers.push(haveFather);
            }

            if (haveFather?.parent) {
                nodesFiltered.push(haveFather);

                findFatherNode2(nodesFiltered, nodesFathers);
            } else {
                findFatherNode2(nodesFiltered, nodesFathers);
            }
        }

        return nodesFathers;
    };

    /**
     * Vuelve a colocar los estados por defecto
     */
    const handleResetSearchTerm = () => {
        setSearchTearm('');
        setTreeEmployeesCopy(treeEmployees);
    };

    /**
     * Se cambia el estado de los empleados seleccionados
     * @param selectedEmployees EmployeeNodeModel[]
     */
    const changeSelectedEmployees = (selectedEmployees: EmployeeNodeModel[]) => {
        setSelectedEmployees(selectedEmployees);
        setEmployeesSelectedBackup(selectedEmployees);
    };

    /**
     * Se llama la función que cambia el estado de los empleados seleccionados
     * @param selectedEmployees
     */
    const handleEmployeesSelectionChange = (
        selectedEmployees: EmployeeNodeModel[]
    ) => {
        changeSelectedEmployees(selectedEmployees);
    };

    /**
     * Subimos el archivo .txt que contiene toda la información de las personas a buscar en el arbol
     * @param e ChangeEvent<HTMLInputElement>
     */
    const handlerUploadFile = async (e: ChangeEvent<HTMLInputElement>) => {
        let file = e.target.files?.[0];

        if (file) {
            if (file.name.endsWith('.txt')) {
                const fileReader = new FileReader();

                fileReader.readAsText(file);

                fileReader.onload = (event) => {
                    const content: string = event.target?.result as string;

                    const documentsList: number[] = content
                        .split('\n')
                        .map((item) => parseFloat(item))
                        .filter((item) => !isNaN(item));

                    const uniqueItems: number[] = Array.from(new Set(documentsList));

                    let filterEmplooyees: EmployeeNodeModel[] = [];
                    let filterParents: EmployeeNodeModel[] = [];

                    treeEmployees.forEach((emp) => {
                        if (uniqueItems?.includes(Number(emp.cardNumber))) {
                            filterEmplooyees.push(emp);
                        }
                    });

                    filterEmplooyees.forEach((empleado) => {
                        const nodosPadres = findParentsNodesByChildNode(
                            treeEmployees,
                            empleado
                        );

                        filterParents.push(...nodosPadres);
                    });

                    const nodosPadresUnicos = Array.from(new Set(filterParents));

                    setTreeEmployeesCopy([
                        ...filterEmplooyees,
                        ...nodosPadresUnicos,
                    ]);

                    let employeesCardNumber = filterEmplooyees.map((emp) =>
                        Number(emp.cardNumber)
                    );

                    let identificationsNotFoundList = uniqueItems
                        ?.filter((id) => !employeesCardNumber.includes(id))
                        .map((e) => e.toString());

                    if (uniqueItems?.length) {
                        setResultOfFilterByIdentifications({
                            status: true,
                            employessFound: getChildNodes(filterEmplooyees).length,
                            employessNotFound: identificationsNotFoundList.length,
                            identificationsNotFound: identificationsNotFoundList,
                        });
                    }
                };

                fileReader.onerror = () => {
                    console.log(fileReader.result);
                };
            } else {
                toast.error(langResources['tree.loader.error.upload.list'], {
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    };

    /**
     * Abrimos el modal de identificaciones que no se encontraron en el arbol al importar el archivs de las fichas de formato .txt
     */
    const handlerOpenIdentificationsModal = () => {
        if (resultOfFilterByIdentifications.employessNotFound > 0) {
            setIsOpenIdentificationModal(true);
        }
    };

    /**
     * Importamos la programación desde un archivo de excel, el lo lee, lo envia a la API y guarda toda la informacion de las programaciones
     * Para que funcione este debe cumplir con los estandares y formatos establecidos
     * @param e ChangeEvent<HTMLInputElement>
     */
    const handleImportProgramation = async (e: ChangeEvent<HTMLInputElement>) => {
        let file = e.target.files?.item(0);

        if (file) {
            if (file.name.endsWith('.xlsx')) {
                const id = toast.loading(langResources['header.syncExcel.loading']);

                let data = new FormData();

                data.append('file', file);

                WorkshiftsSchedulingAPI.importSchedulings(data)
                    .then((res) => {
                        const {
                            endDate,
                            startDate,
                            employeeIds,
                            hasCodesWithErrors,
                            message,
                        } = res;

                        setIsImportSchedulings(true);

                        let employees: EmployeeNodeModel[] = treeEmployees.filter(
                            (emp) => res.employeeIds.includes(Number(emp.id))
                        );

                        setEndDateScheduling(res.endDate.split('T')[0]);
                        setStartDateScheduling(res.startDate.split('T')[0]);

                        const filterEmplooyees: EmployeeNodeModel[] = [];

                        let idExistingGroups = employees.map((emp) => emp.id);

                        treeEmployees.forEach((emp) => {
                            if (idExistingGroups.includes(emp.id)) {
                                const parent = treeEmployeesCopy.find(
                                    (e) => e.id === emp.parent
                                );

                                if (
                                    parent !== undefined &&
                                    !filterEmplooyees.includes(parent)
                                ) {
                                    filterEmplooyees.push(parent);
                                }

                                if (!filterEmplooyees.includes(emp)) {
                                    filterEmplooyees.push(emp);
                                }
                            }
                        });

                        setEmployeesFromTemplate(filterEmplooyees);
                        setEmployeesToShowTable(filterEmplooyees);
                        setTreeEmployeesCopy(filterEmplooyees);

                        handleConsultScheduling(
                            employees,
                            res.startDate.split('T')[0],
                            res.endDate.split('T')[0],
                            false,
                            []
                        );

                        if (res.hasCodesWithErrors) {
                            toast.update(id, {
                                render: langResources['header.syncExcel.warning'],
                                type: 'warning',
                                isLoading: false,
                                autoClose: 5000,
                                position: toast.POSITION.BOTTOM_RIGHT,
                                closeOnClick: true,
                                closeButton: true,
                            });
                        } else {
                            toast.update(id, {
                                render: message
                                    ? message
                                    : langResources['header.syncExcel.success'],
                                type: 'success',
                                isLoading: false,
                                autoClose: 5000,
                                position: toast.POSITION.BOTTOM_RIGHT,
                                closeOnClick: true,
                                closeButton: true,
                            });
                        }
                    })
                    .catch((err) => {
                        let input: HTMLInputElement = document.getElementById(
                            'form-import-template'
                        ) as HTMLInputElement;

                        input.value = '';
                        setIsImportSchedulings(false);
                        toast.update(id, {
                            render: `${err.message}`,
                            type: 'error',
                            isLoading: false,
                            autoClose: 5000,
                            position: toast.POSITION.BOTTOM_RIGHT,
                            closeOnClick: true,
                            closeButton: true,
                        });
                    });
            } else {
                toast.error(langResources['header.syncExcel.validation.error'], {
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    };

    /**
     * Reseteamos todos los valores de los estados a su estado por defecto
     * @param inputId string
     */
    const handlerResetProgramation = (inputId: string) => {
        let input: HTMLInputElement = document.getElementById(
            `${inputId}`
        ) as HTMLInputElement;

        input.value = '';
        setIsImportSchedulings(false);
        setTreeEmployeesCopy(treeEmployees);
        setEmployeesFromTemplate([]);
        setEmployeesToShowTable([]);
        setSelectedEmployees([]);
        setShowEmployeesTable(false);
        setEndDateScheduling('');
        setStartDateScheduling('');
    };

    useEffect(() => {
        if (employeesToShowTable.length == 0) {
            setShowEmployeesTable(false);
        }
    }, [employeesToShowTable]);

    useEffect(() => {
        const snapshot = restoreOvertimeHomeStateIfPending({
            setSelectedEmployees,
            setEmployeesSelectedBackup,
            setEmployeesToShowTable,
            setStartDateScheduling,
            setEndDateScheduling,
            setShowEmployeesTable,
            setEmployeesFromTemplate,
            setIsCollapseTree,
        });

        if (snapshot) {
            pendingRestoreSnapshotRef.current = snapshot;
        }
    }, []);

    useEffect(() => {
        const snapshot = pendingRestoreSnapshotRef.current;
        if (isLoadingTree || !snapshot || treeEmployees.length === 0) return;

        const nodeIds = snapshot.selectedNodeIds?.length
            ? snapshot.selectedNodeIds
            : snapshot.selectedEmployees.map((e) => e.id);

        const reconciled = reconcileNodesWithTree(treeEmployees, nodeIds);

        setSelectedEmployees(reconciled);
        setEmployeesSelectedBackup(reconciled);
        setEmployeesToShowTable(reconciled);
        setEmployeesFromTemplate(reconciled);
        setIsCollapseTree(false);

        if (
            reconciled.length &&
            snapshot.startDateScheduling &&
            snapshot.endDateScheduling
        ) {
            handleConsultScheduling(
                reconciled,
                snapshot.startDateScheduling,
                snapshot.endDateScheduling,
                false,
                [],
            );
        }

        pendingRestoreSnapshotRef.current = null;
    }, [isLoadingTree, treeEmployees]);

    return (
        <div className=''>
            {/* Menu superior de la aplicación */}
            <MenuBar
                setTypeOfPerson={setTypeOfPerson}
                typeOfPerson={typeOfPerson}
                setStartDateScheduling={setStartDateScheduling}
                startDateScheduling={startDateScheduling}
                endDateScheduling={endDateScheduling}
                setEndDateScheduling={setEndDateScheduling}
                contractorsList={contractorsList}
                selectedEmployees={selectedEmployees}
                setTreeEmployeesCopy={setTreeEmployeesCopy}
                setTreeEmployees={setTreeEmployees}
                setEmployeesToShowTable={setEmployeesToShowTable}
                setContractorSelected={setContractorSelected}
                setIsOpenFilterDailyAssistance={setIsOpenFilterDailyAssistance}
                setIsOpenFilterInterruptionsRepotModal={
                    setIsOpenFilterInterruptionsRepotModal
                }
                setIsOpenFilterLunchTimeControl={setIsOpenFilterLunchTimeControl}
                setIsOpenFilterUnattendanceInterruptionsReportModal={
                    setIsOpenFilterUnattendanceInterruptionsReportModal
                }
                setIsOpenFilterWorkingSchedulingsRepotModal={
                    setIsOpenFilterWorkingSchedulingsRepotModal
                }
                setSelectedEmployees={handleEmployeesSelectionChange}
                setGroupList={setGroupList}
            />

            {/* Arbol de empleados*/}
            <div className='container__dashboard'>
                <TreeEmployees
                    handleEmployeesSelectionChange={handleEmployeesSelectionChange}
                    handleResetSearchTerm={handleResetSearchTerm}
                    handleSearchInput={handleFilterEmployeeSelection}
                    handlerUploadFile={handlerUploadFile}
                    handlerOpenIdentificationsModal={handlerOpenIdentificationsModal}
                    setIsCollapseTree={setIsCollapseTree}
                    setIsSelectAllEmployes={setIsSelectAllEmployes}
                    setResultOfFilterByIdentifications={
                        setResultOfFilterByIdentifications
                    }
                    setTreeEmployeesCopy={setTreeEmployeesCopy}
                    employeesFromTemplate={employeesFromTemplate}
                    searchTearm={searchTearm}
                    resultOfFilterByIdentifications={resultOfFilterByIdentifications}
                    isSelectAllEmployes={isSelectAllEmployes}
                    isCollapseTree={isCollapseTree}
                    isLoadingTree={isLoadingTree}
                    treeEmployees={treeEmployees}
                    treeEmployeesCopy={treeEmployeesCopy}
                    isImportSchedulings={isImportSchedulings}
                    handlerResetProgramation={handlerResetProgramation}
                    handleImportProgramation={handleImportProgramation}
                    typeOfPerson={typeOfPerson}
                    contractorSelected={contractorSelected}
                />

                {/* Tabla o grilla de la programación */}
                {showEmployeesTable &&
                    getChildNodes(selectedEmployees).length > 0 &&
                    selectedEmployees.length > 0 && (
                        <EmployeesTable
                            selectedEmployees={employeesToShowTable}
                            selectedEmployeesCopy={selectedEmployees}
                            groupList={groupList}
                            consultInfoScheduling={handleConsultScheduling}
                            startDate={startDateScheduling}
                            endDate={endDateScheduling}
                            isCollapseTree={isCollapseTree}
                        />
                    )}
            </div>

            <ReportsModalsWrapper
                isOpenFilterUnattendanceInterruptionsReportModal={
                    isOpenFilterUnattendanceInterruptionsReportModal
                }
                isOpenFilterWorkingSchedulingsRepotModal={
                    isOpenFilterWorkingSchedulingsRepotModal
                }
                isOpenFilterInterruptionsRepotModal={
                    isOpenFilterInterruptionsRepotModal
                }
                isOpenFilterDailyAssistance={isOpenFilterDailyAssistance}
                isOpenFilterLunchTimeControl={isOpenFilterLunchTimeControl}
                setIsOpenFilterUnattendanceInterruptionsReportModal={
                    setIsOpenFilterUnattendanceInterruptionsReportModal
                }
                setIsOpenFilterWorkingSchedulingsRepotModal={
                    setIsOpenFilterWorkingSchedulingsRepotModal
                }
                setIsOpenFilterInterruptionsRepotModal={
                    setIsOpenFilterInterruptionsRepotModal
                }
                setIsOpenFilterDailyAssistance={setIsOpenFilterDailyAssistance}
                setIsOpenFilterLunchTimeControl={setIsOpenFilterLunchTimeControl}
                startDateScheduling={startDateScheduling}
                endDateScheduling={endDateScheduling}
                selectedEmployees={selectedEmployees}
            />

            <BaseConfirmModal
                isLoading={false}
                onClose={() => setIsOpenIdentificationModal(false)}
                onSubmit={() => setIsOpenIdentificationModal(false)}
                modalTitle={`${langResources['tree.identifications.not.found.modal.title']}: ${resultOfFilterByIdentifications.employessNotFound}`}
                isOpen={isOpenIdentificationModal}
                isShowControls={false}
            >
                <div className='modal-body pt-1'>
                    <ul className='d-flex flex-wrap gap-1'>
                        {resultOfFilterByIdentifications.identificationsNotFound?.map(
                            (id) => (
                                <li
                                    key={id}
                                    className='fs-5 col p-0'
                                    style={{ minWidth: 120 }}
                                >
                                    {id}
                                </li>
                            )
                        )}
                    </ul>
                </div>
            </BaseConfirmModal>
        </div>
    );
};
